<div [formGroup]="resourceFormGroup" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="number"
    [placeholder]="'rentModule.resourceDialogComponent.fields.number.placeholder' | translate"
    [label]="'rentModule.resourceDialogComponent.fields.number.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="name"
    [placeholder]="'rentModule.resourceDialogComponent.fields.name.placeholder' | translate"
    [label]="'rentModule.resourceDialogComponent.fields.name.label' | translate">
  </nx-edit-text-input>
  <nx-edit-multiselect-input
    formControlName="functions"
    [label]="'rentModule.resourceDialogComponent.fields.functions.label' | translate"
    [options]="functions">
  </nx-edit-multiselect-input>
  <nx-edit-select-input
    formControlName="location"
    [label]="'rentModule.resourceDialogComponent.fields.location.label' | translate"
    [options]="locations">
  </nx-edit-select-input>
<div>
